module.exports = __webpack_public_path__ + "static/media/404.bcd03d48.png";